export const classes = {
  form: 'w-full flex flex-col gap-4',
  button: 'mt-4 transition-opacity opacity-1',
  hidden: 'opacity-0 pointer-events-none',
};
